var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VisitInfoForm',{ref:"refVisitInfoForm",attrs:{"visitData":_vm.visitData}})
}
var staticRenderFns = []

export { render, staticRenderFns }